/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Links_LabelInputs */

const cs_links_label = /** @type {(inputs: Links_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Popisek`)
};

const en_links_label = /** @type {(inputs: Links_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Label`)
};

/**
* | output |
* | --- |
* | "Label" |
*
* @param {Links_LabelInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const links_label = /** @type {((inputs?: Links_LabelInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Links_LabelInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_links_label(inputs)
	return cs_links_label(inputs)
});